import {Player} from '@lottiefiles/react-lottie-player';
import React from 'react';
import {Body, Headline} from '@lightricks/react-design-system';
import reonboardingLottieAnimation from '@/assets/lotties/reonboarding.json';
import translate from '@/utils/translate';
import styles from './Reonboarding.module.scss';

export type ReonboardingProps = {
  title: string;
  subtitle: string;
};

export default function Reonboarding({title, subtitle}: ReonboardingProps) {
  return (
    <div className={styles.reonboardingContainer}>
      <Player
        autoplay
        keepLastFrame
        loop
        src={reonboardingLottieAnimation}
        className={styles.reonboardingAnimation}
      />
      <div className={styles.reonboardingText}>
        <Headline size="xl">{title}</Headline>
        <Body size="lg">{subtitle}</Body>
      </div>
    </div>
  );
}
